<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <router-view></router-view>
      </div>
      <export-components :apiFunction="downloadRequest" :requestData="getSearch({...sendData[activeTab]})" :option="option"
        @sendData=getSearchData></export-components>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true"
      :table-col-check="{isShow:true,name:'RequestMail2' + activeTab}" :key="activeTab" ref="wMyTable"
      :page="page" @pageChange="handlePagePagination($event)" :isShowRowSelection="true">
      <div slot="operation" slot-scope="{text,record}">
        <el-button size="mini" v-if="activeTab === 'new'" type="success" @click="handleMail(record)">填写快递单号</el-button>
        <el-button size="mini" v-if="activeTab === 'new'" type="danger" @click="handleNot(record)">取消邮寄</el-button>
      </div>
      <div slot="recipient" slot-scope="{record}">
        <span v-if="record.recipientName">{{record.recipientName + ',' + record.recipientPhone + ',' +
          record.recipientAddress}}</span>
      </div>
      <div slot="status" slot-scope="{record}">
        <div class="status-tag-container" v-if="record.status!=='DEFEAT'">
          <el-tag v-if="record['trackingFlag'] === 1" type="success">已邮寄</el-tag>
          <el-tag v-else-if="record['trackingFlag'] === 0" type="warning">待邮寄</el-tag>
          <el-tag v-else type="info">未知状态</el-tag>
        </div>
        <div v-else>
          <span v-if="record['status'] === 'DEFEAT'" style="display: flex;align-items: center">
            <el-tag type="danger">
              <span>已取消</span>
            </el-tag>
            <w-ellipsis-and-look style="margin-left:5px" class="w-ellipsis-and-look" :text="record.rejectionReason"
              :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
            </w-ellipsis-and-look>
          </span>
        </div>
      </div>
      <div slot="material" slot-scope="{record,index}"
        v-if="record.materialRequestDetailDTOS && record.materialRequestDetailDTOS.length>0">
        <ex-fold-cell-too :data="materialData" :unit="record.materialType === 'PROTECT_REAGENT'?'specs':null"
          :index="index" :record="record.materialRequestDetailDTOS"></ex-fold-cell-too>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <request-details v-if="showDetailsDialog" :show-dialog="showDetailsDialog" :select-detail="showDetails"
      @submit="close"></request-details>
    <request-mail-dialog v-if="showRequestMail" :show-dialog="showRequestMail" :select-detail="RequestMails"
      @submit="closeShowRequestMail"></request-mail-dialog>
    <not-arrange-mail v-if="showNotMail" select-type="materialMail" :show-dialog="showNotMail" :select-detail="notMail"
      @submit="closeNotDialog"></not-arrange-mail>
  </div>
</template>

<script>

import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import ExFoldCellToo from "@/components/ExFoldCellToo.vue";
import RequestDetails from "@/components/material/Request/RequestDetails.vue";
import RequestMailDialog from "@/components/material/Request/RequestMailDialog.vue";
import {requestMails} from "@/utils/data/tableCol/material/requestMail/requestMails";
import {requestMail} from "@/utils/data/tableCol/material/requestMail/requestMail";
import {downloadRequest, getRequestPage} from "@/api/dilivery/material/request";
import {needRedDoltInfo} from "@/utils/data/basicData/leftNavData";
import NotArrangeMail from "@/components/mail/NotArrangeMail.vue";
import {getDataInLocalStorage} from "@/utils/localStorage";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import _ from "lodash";
import ExportComponents from "@/components/ExportComponents.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";

export default {
  name: "RequestMail",
  components: {
    ExportComponents,
    PictureLoading,
    NotArrangeMail, RequestMailDialog, RequestDetails, ExFoldCellToo, ExFoldTable, TableHeadNote},
  mixins: [tableOperationMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      activeTab: 'new',
      loading: true,
      materialData: {name: 'materialLexiconDTO.materialName', value: 'number'},
      data: [
        { label: '全部', name: 'all', showBadge: false },
        { label: '待邮寄', name: 'new', showBadge: true },
        { label: '已邮寄', name: 'history', showBadge: false },
        { label: '已取消', name: 'cancel', showBadge: false },
      ],
      sendData: {
        all: { "query#materialType.NE": "DRY_ICE" },
        new: { "query#materialType.NE": "DRY_ICE", "query#status.EQ": "SUCCESS", "query#trackingFlag.EQ": 0 },
        history: { "query#materialType.NE": "DRY_ICE", "query#status.EQ": "SUCCESS", "query#trackingFlag.EQ": 1 },
        cancel: { "query#materialType.NE": "DRY_ICE", "query#status.EQ": "DEFEAT" },
      },
      pageTotal: { all: 0, new: 0, history: 0, cancel: 0 },
      option: [
        {label: '处理时间', value: 'operatingTime'},
        {label: '创建时间', value: 'createTime'},
      ],
      showRequestMail: false,
      RequestMails: '',
      showDetailsDialog: false,
      showDetails: '',
      showNotMail: false,
      notMail: '',
    }
  },
  computed: {
    columns() {
      if (this.activeTab === 'new') {
        return JSON.parse(JSON.stringify(requestMail([] || {})))
      } else {
        return JSON.parse(JSON.stringify(requestMails([] || {})))
      }
    },
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  methods: {
    downloadRequest,
    loadAllTabTotals() {
      Object.keys(this.sendData).forEach(tabName => {
        let sendData = { ...this.sendData[tabName] }
        getRequestPage({ 'page.current': 1, 'page.size': 1 }, sendData).then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    // 获取邮寄表数据
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      };
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] };
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getRequestPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.currentNum = parseInt(res.data.current);
          this.page.pageSize = parseInt(res.data.size);
          this.page.total = parseInt(res.data.total);
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
      }).catch(error => {
        this.loading = false
      });
    },
    getSearch(sendData) {
      
      const keys = ['salesName']
      this.searchConditionTag.forEach(item => {
        if (this.option.map(item => item.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else if (keys.includes(item.key)) {
          sendData[item.key] = item.value
        } else {
          sendData["query#" + item.key + ".LIKE"] = item.value
        }
      })
      return sendData
    },
    handleNot(row) {
      this.notMail = row
      this.showNotMail = true
    },
    closeNotDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showNotMail = false
      })
    },
    handleMail(row) {
      this.RequestMails = row
      this.showRequestMail = true
    },
    handleDetails(row) {
      this.showDetails = row
      this.showDetailsDialog = true
    },
    closeShowRequestMail(type) {
      if (type === 'confirm') {
        this.getData()
        this.$store.commit('right/setChangeRed', true)
      }
      this.showRequestMail = false
    },
    //关闭详情弹出框
    close() {
      this.$nextTick(() => {
        this.showDetailsDialog = false
      })
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中，如果需要 */
  height: 100%; /* 确保标签在单元格中垂直居中 */
}
</style>
